<template>
  <DocWord
    trackId="openplat_serviceagreement_page_load"
    :versionOptions="versionOptions"
  >
  </DocWord>
</template>

<script>
import DocWord from '../../../components/DocWord.vue'
import versionOptions from './versions'

export default {
  components: {
    DocWord,
  },
  data() {
    return {
      versionOptions,
    }
  },
}
</script>
